export default "__VITE_ASSET__451f2803__"